import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Hook to generate paths that preserve specific search parameters
 * Useful for maintaining state (like tenant selection) across navigation
 */
export function usePreserveSearchParams() {
  const [searchParams] = useSearchParams();

  /**
   * Creates a path with preserved search parameters
   * @param path - The base path to navigate to
   * @param paramsToPreserve - Array of parameter names to preserve (defaults to ['tenant'])
   * @returns Path with preserved search parameters
   */
  const createPath = useCallback((path: string, paramsToPreserve: string[] = ['tenant']) => {
    const preservedParams = new URLSearchParams();

    paramsToPreserve.forEach(param => {
      const value = searchParams.get(param);
      if (value) {
        preservedParams.set(param, value);
      }
    });

    const queryString = preservedParams.toString();
    return queryString ? `${path}?${queryString}` : path;
  }, [searchParams]);

  return { createPath };
}
